import { render, staticRenderFns } from "./SparepartsItemDialogForm.vue?vue&type=template&id=2b8f5e4a&"
import script from "./SparepartsItemDialogForm.vue?vue&type=script&lang=js&"
export * from "./SparepartsItemDialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports